// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const replaceItemAtIndex = <T extends unknown>(
    items: T[],
    index: number,
    item: T,
) => {
    return [...items.slice(0, index), item, ...items.slice(index + 1)];
};
